var IS_PRODUCTION = process.env.NODE_ENV === 'production';

export { IS_PRODUCTION };
